/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonPassResponse } from './SeasonPassResponse';
import {
    SeasonPassResponseFromJSON,
    SeasonPassResponseFromJSONTyped,
    SeasonPassResponseToJSON,
    SeasonPassResponseToJSONTyped,
} from './SeasonPassResponse';

/**
 * 
 * @export
 * @interface AdminListSeasonPassesResponse
 */
export interface AdminListSeasonPassesResponse {
    /**
     * 
     * @type {Array<SeasonPassResponse>}
     * @memberof AdminListSeasonPassesResponse
     */
    seasonPasses: Array<SeasonPassResponse>;
    /**
     * 
     * @type {number}
     * @memberof AdminListSeasonPassesResponse
     */
    total: number;
}

/**
 * Check if a given object implements the AdminListSeasonPassesResponse interface.
 */
export function instanceOfAdminListSeasonPassesResponse(value: object): value is AdminListSeasonPassesResponse {
    if (!('seasonPasses' in value) || value['seasonPasses'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function AdminListSeasonPassesResponseFromJSON(json: any): AdminListSeasonPassesResponse {
    return AdminListSeasonPassesResponseFromJSONTyped(json, false);
}

export function AdminListSeasonPassesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListSeasonPassesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonPasses': ((json['seasonPasses'] as Array<any>).map(SeasonPassResponseFromJSON)),
        'total': json['total'],
    };
}

export function AdminListSeasonPassesResponseToJSON(json: any): AdminListSeasonPassesResponse {
    return AdminListSeasonPassesResponseToJSONTyped(json, false);
}

export function AdminListSeasonPassesResponseToJSONTyped(value?: AdminListSeasonPassesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonPasses': ((value['seasonPasses'] as Array<any>).map(SeasonPassResponseToJSON)),
        'total': value['total'],
    };
}

